"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNextPronunciationLessonDuration = exports.getPronunciationLevelDuration = exports.getPronunciationLessonItemDuration = exports.sortPronunciationItems = exports.calculatePronunciationLevelProgress = exports.toPronunciationLessonWithProgress = exports.toPronunciationLessonsWithProgress = exports.getIncompleteItemsInPronunciationLesson = exports.getRemainingPronunciationLessonsWithProgress = exports.getWatchedVideos = exports.getVideos = exports.isPronunciationInteractiveTaskAvailableForPronunciationLevel = exports.isPronunciationLessonItemCompleted = exports.getIsTooAdvancedForEarTraining = exports.getIsTooAdvancedForBasicsOfSpelling = exports.isEarTraining = exports.isPronunciation = exports.isVideo = void 0;
const types_1 = require("@fluent-forever/types");
const R = __importStar(require("ramda"));
const FF = __importStar(require("./ff"));
const isVideo = (item) => item.type === "VIDEO";
exports.isVideo = isVideo;
const isPronunciation = (item) => item.type === "PRONOUNCE";
exports.isPronunciation = isPronunciation;
const isEarTraining = (item) => item.type === "EAR_TRAINING";
exports.isEarTraining = isEarTraining;
const getIsTooAdvancedForBasicsOfSpelling = (pronunciationLevel) => pronunciationLevel !== types_1.PronunciationLevel.Beginner;
exports.getIsTooAdvancedForBasicsOfSpelling = getIsTooAdvancedForBasicsOfSpelling;
const getIsTooAdvancedForEarTraining = (pronunciationLevel) => pronunciationLevel === types_1.PronunciationLevel.Advanced;
exports.getIsTooAdvancedForEarTraining = getIsTooAdvancedForEarTraining;
const isPronunciationLessonItemCompleted = (item) => {
    if (exports.isVideo(item))
        return Boolean(item.first_view);
    return Boolean(item.last_view);
};
exports.isPronunciationLessonItemCompleted = isPronunciationLessonItemCompleted;
const isPronunciationInteractiveTaskAvailableForPronunciationLevel = (level, task) => level === types_1.PronunciationLevel.Beginner ||
    (level === types_1.PronunciationLevel.Intermediate && task.type === "EAR_TRAINING");
exports.isPronunciationInteractiveTaskAvailableForPronunciationLevel = isPronunciationInteractiveTaskAvailableForPronunciationLevel;
const getVideos = (pronunciationLevelItems) => R.filter(exports.isVideo, pronunciationLevelItems);
exports.getVideos = getVideos;
const getWatchedVideos = (pronunciationLevelItems) => R.filter((video) => exports.isPronunciationLessonItemCompleted(video), exports.getVideos(pronunciationLevelItems));
exports.getWatchedVideos = getWatchedVideos;
const getRemainingPronunciationLessonsWithProgress = (pronunciationLessons, userPronunciationLevel) => {
    const pronunciationLessonsForUser = exports.toPronunciationLessonsWithProgress(pronunciationLessons, userPronunciationLevel);
    return R.reject((pronunciationLevel) => pronunciationLevel.progress === 100, pronunciationLessonsForUser);
};
exports.getRemainingPronunciationLessonsWithProgress = getRemainingPronunciationLessonsWithProgress;
const getIncompleteItemsInPronunciationLesson = (pronunciationLesson) => {
    return R.reject(exports.isPronunciationLessonItemCompleted, pronunciationLesson.items);
};
exports.getIncompleteItemsInPronunciationLesson = getIncompleteItemsInPronunciationLesson;
const toPronunciationLessonsWithProgress = (pronunciationLevels, userPronunciationLevel) => pronunciationLevels.map((pronunciationLevel) => exports.toPronunciationLessonWithProgress(pronunciationLevel, userPronunciationLevel));
exports.toPronunciationLessonsWithProgress = toPronunciationLessonsWithProgress;
const toPronunciationLessonWithProgress = (pronunciationLevel, userPronunciationLevel) => {
    const pronunciationLevelItems = pronunciationLevel.items.filter((item) => exports.isVideo(item) ||
        exports.isPronunciationInteractiveTaskAvailableForPronunciationLevel(userPronunciationLevel, item));
    return {
        ...pronunciationLevel,
        items: pronunciationLevelItems,
        progress: exports.calculatePronunciationLevelProgress(pronunciationLevelItems),
    };
};
exports.toPronunciationLessonWithProgress = toPronunciationLessonWithProgress;
const calculatePronunciationLevelProgress = (pronunciationLevelItems) => {
    const completedPronunciationLevelItems = pronunciationLevelItems.filter(exports.isPronunciationLessonItemCompleted);
    return FF.calculatePercentage(completedPronunciationLevelItems.length, pronunciationLevelItems.length);
};
exports.calculatePronunciationLevelProgress = calculatePronunciationLevelProgress;
const sortPronunciationItems = (items) => {
    const videos = items
        .filter(exports.isVideo)
        .sort((v1, v2) => v1.watch_order - v2.watch_order);
    const pronunciationLessons = items.filter(exports.isPronunciation);
    const earTrainingLessons = items.filter(exports.isEarTraining);
    const pronunciationItems = R.flatten([
        pronunciationLessons,
        R.take(1, videos),
        earTrainingLessons,
        R.drop(1, videos),
    ]);
    return R.reject(R.isNil, pronunciationItems);
};
exports.sortPronunciationItems = sortPronunciationItems;
const getPronunciationLessonItemDuration = (pronunciationLessonItem) => {
    return exports.isVideo(pronunciationLessonItem)
        ? pronunciationLessonItem.duration
        : exports.isPronunciation(pronunciationLessonItem)
            ? 3
            : 1;
};
exports.getPronunciationLessonItemDuration = getPronunciationLessonItemDuration;
// Returns Pronunciation level duration in minutes
const getPronunciationLevelDuration = (pronunciationLevel) => {
    const incompletePronunciationLevelItems = exports.getIncompleteItemsInPronunciationLesson(pronunciationLevel);
    return R.reduce((acc, item) => acc + exports.getPronunciationLessonItemDuration(item), 0, incompletePronunciationLevelItems);
};
exports.getPronunciationLevelDuration = getPronunciationLevelDuration;
// Returns Next Pronunciation level duration in minutes
const getNextPronunciationLessonDuration = (remainingPronunciationLevels) => R.isEmpty(remainingPronunciationLevels)
    ? 0
    : exports.getPronunciationLevelDuration(remainingPronunciationLevels[0]);
exports.getNextPronunciationLessonDuration = getNextPronunciationLessonDuration;
//# sourceMappingURL=pronunciation_utils.js.map